<template>
  <crud-list
    :datasource="datasource"
    :capabilities="capabilities"
    :callRefresh="callRefresh"
    @item-selected="selectedItemTraitements"
    ref="datasourceRef"
  >
    <template #search>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template #activator="data">
          <v-btn
            fab
            small
            color="primary"
            v-on="data.on"
            @click="exportExcelParticipantHistoBilan()"
            :loading="loading"
          >
            <v-icon color="white">fa-file-excel</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('adherents.tooltip.export') }}</span>
      </v-tooltip>
    </template>
    <template #table>
      <datasource-table :datasource="datasource">
        <template #item="{ item }">
          <tr>
            <td>
              {{ item.id }}
            </td>
            <td>
              {{ item.name }}
            </td>
            <td>
              {{ dateFormatter(item.dateDeNaissance) }}
            </td>
            <td>
              {{ item.age }}
            </td>
            <td>
              {{ dateFormatter(item.dateAdhesion) }}
            </td>
            <td>
              {{ dateFormatter(item.dateResiliation) }}
            </td>
            <td>
              {{ item.gestionRDV }}
            </td>
            <td>
              {{ item.periodicite }}
            </td>
            <td>
              {{ dateFormatter(item.dateClotureN2) }}
            </td>
            <td>
              {{ dateFormatter(item.dateClotureN1) }}
            </td>
            <td>
              {{ dateFormatter(item.dateClotureN) }}
            </td>
            <td>
              {{ dateFormatter(item.dateProchainBilan) }}
            </td>
          </tr>
        </template>
      </datasource-table>
    </template>
  </crud-list>
</template>

<script>
import Datasource from '@/utils/datasource'
import DateFormatter from '@/plugins/mixins/DateFormatter'
import CSVMixin from '@/plugins/mixins/CSVMixin'

export default {
  mixins: [DateFormatter, CSVMixin],
  props: {
    fieldName: {
      type: String,
      default: '_link',
    },
    capabilities: {
      type: String,
      default: 'search',
    },
    rowsSize: {
      type: Number,
      default: 15,
    },
    callRefresh: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.$nextTick(function () {
      // this.datasource.args.idTechnique = this.$auth.idTechnique();
      this.datasource.refresh()
    })
  },
  data() {
    const datasource = new Datasource('historiqueBilansCorrespondant', {
      page: 1,
      rowsPerPage: this.rowsSize,
      sortBy: 'name',
      descending: false,
      args: {},
      customRowClass: (item) => (item.actif ? '' : 'inactive-item'),
      linkClass: (item) => (item.actif ? '' : 'inactif'),
      fields: [
        {
          value: 'id',
          text: this.$t('adherents.bilans.list.headers.id'),
          linkTo: this.linkTo,
          sortable: true,
        },
        {
          value: 'name',
          text: this.$t('adherents.bilans.list.headers.name'),
          sortable: true,
        },
        {
          value: 'dateDeNaissance',
          text: this.$t('adherents.bilans.list.headers.dateDeNaissance'),
          sortable: true,
        },
        {
          value: 'age',
          text: this.$t('adherents.bilans.list.headers.age'),
          sortable: true,
        },
        {
          value: 'dateAdhesion',
          text: this.$t('adherents.bilans.list.headers.dateAdhesion'),
          sortable: true,
        },
        {
          value: 'dateResiliation',
          text: this.$t('adherents.bilans.list.headers.dateResiliation'),
          sortable: true,
        },
        {
          value: 'gestionRDV',
          text: this.$t('adherents.bilans.list.headers.gestionRDV'),
          sortable: true,
        },
        {
          value: 'periodicite',
          text: this.$t('adherents.bilans.list.headers.periodicite'),
          sortable: true,
        },
        {
          value: 'dateClotureN2',
          text: this.$t('adherents.bilans.list.headers.dateBilanN2'),
          sortable: true,
        },
        {
          value: 'dateClotureN1',
          text: this.$t('adherents.bilans.list.headers.dateBilanN1'),
          sortable: true,
        },
        {
          value: 'dateClotureN',
          text: this.$t('adherents.bilans.list.headers.dateBilanN0'),
          sortable: true,
        },
        {
          value: 'dateProchainBilan',
          text: this.$t('adherents.bilans.list.headers.dateProchainBilan'),
          sortable: true,
        },
      ],
    })

    return {
      datasource,
      loading: false,
    }
  },
  computed: {},

  methods: {
    selectedItemTraitements(item) {
      this.$emit('item-selected', item)
    },
    exportExcelParticipantHistoBilan() {
      return this.downloadFile(
        '/excel-participant-historique-bilan',
        'historique-bilan.xls',
        null,
        'arraybuffer',
      )
    },
  },
}
</script>
